export default __webpack_public_path__ + "static/media/Clinical.2d4498cb.png";